// extracted by mini-css-extract-plugin
export var calendarView = "_52-0";